import { Injectable } from '@angular/core';

import { MemoryCacheRepository } from './memory-cache.repository';
import { UserInterface } from '../data';

@Injectable()
export class UserCacheRepository extends MemoryCacheRepository<UserInterface> {}
